<script>
// Motivo da nota + Ação recomendada como timeline: uma linha vertical à
// esquerda liga dois pontos — o Motivo (alvo) em cima e a Recomendação (lâmpada
// verde) embaixo, em caixa com tint claro do success e rótulo "Recomendação:"
// inline. Hierarquia via az-text-primary (títulos) × az-text-secondary (corpo).
export default {
  name: 'TranscriptReasonAction',
  props: {
    reason: { type: String, default: '' },
    recommendation: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="transcript-reason-action">
    <!-- Motivo -->
    <div class="transcript-reason-action__item">
      <span class="transcript-reason-action__dot">
        <icon-svg name="mdi-target" :size="18" color="#5B5B5B" />
      </span>
      <div class="transcript-reason-action__content">
        <p class="az-text-primary az-size-12 font-semibold mb-1">Motivo</p>
        <p class="az-text-primary az-size-14 mb-0">
          {{ reason || 'Sem justificativa registrada.' }}
        </p>
      </div>
    </div>

    <!-- Ação recomendada -->
    <div v-if="recommendation" class="transcript-reason-action__item">
      <span
        class="transcript-reason-action__dot transcript-reason-action__dot--action"
      >
        <icon-svg name="lamp-on" :size="16" color="var(--success)" />
      </span>
      <div class="transcript-reason-action__content">
        <div class="transcript-reason-action__action rounded-sm pa-3">
          <p class="az-text-primary az-size-14 mb-0">
            <span class="transcript-reason-action__action-label">
              Recomendação:
            </span>
            {{ recommendation }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.transcript-reason-action
  position: relative

  // Linha vertical ligando os pontos (atrás deles).
  &::before
    content: ''
    position: absolute
    left: 11px
    top: 14px
    bottom: 14px
    width: 1px
    background: #E4E0E6

  &__item
    position: relative
    padding-left: 36px

    &:not(:last-child)
      margin-bottom: 12px

  // Ponto sobre a linha — fundo igual ao card (flat-gray) "quebra" a linha nele.
  // top alinha o centro do ponto à primeira linha de texto do item.
  &__dot
    position: absolute
    left: 0
    top: -2px
    width: 22px
    height: 22px
    display: flex
    align-items: center
    justify-content: center
    background: #F8F9FA
    border-radius: 50%
    z-index: 1

    // Na ação o texto fica dentro da caixa (pa-3) → desce o ponto p/ alinhar
    // com "Recomendação:".
    &--action
      top: 8px

  // Caixa da recomendação: tint claro do success (token global --transcript-success-bg-soft).
  &__action
    background-color: var(--transcript-success-bg-soft)

  // Rótulo "Recomendação:" inline na cor do success.
  &__action-label
    color: var(--success)
    font-weight: 600
</style>
